export default __webpack_public_path__ + "static/media/react.f1484e29.svg";